export default "__VITE_ASSET__DjwodaID__"